export const BASE_URL = "https://msmestores.com/api/v1/website/";

// export const BASE_URL = "http://localhost/indian_msme_api/api/v1/website/";

export const SELLER_LOGIN_URL = "https://seller.indianmsme.org";
export const BUYER_LOGIN_URL = "https://buyer.indianmsme.org";

export const LOGO = require("../assets/logo.png");

export const defaultCategoryImage = require("../assets/images/product/colthes/1.jpg");
export const defaultProductImage = require("../assets/images/no_image.png");

export const AOA = require("../assets/certification/aoa.pdf");
export const MOA = require("../assets/certification/moa.pdf");
export const PAN = require("../assets/certification/pan.pdf");
export const COI = require("../assets/certification/coi.pdf");
export const SCHEME = require("../assets/images/scheme.pdf");
export const RACK_IMAGE = require("../assets/images/rack_branding.png");
export const SHELF_IMAGE = require("../assets/images/shelf_branding.png");

export const PRODUCT_NOT_FOUND = require("../assets/images/no_product.png");

export const MSME_USER_TOKEN = "@INDIAN_MSME_USER_TOKEN";
export const MSME_USER_ORDER_DETAILS = "@INDIAN_MSME_USER_ORDER_DETAILS";
export const MSME_USER_TYPE = "@INDIAN_MSME_USER_TYPE";
export const MSME_USER_ID = "@INDIAN_MSME_USER_ID";
export const MSME_USER_ADDRESS = "@INDIAN_MSME_USER_ADDRESS";

export const MSME_CITY = "@INDIAN_MSME_CITY";
export const MSME_SEARCH = "@INDIAN_MSME_SEARCH";

export const GUEST_SESSION_ID = "@INDIAN_MSME_GUEST_SESSION_ID";
export const PAYMENT_DETAILS = "@INDIAN_MSME_PAYMENT_DETAILS";
export const MSME_USER_ACCOUNT_ID = "@INDIAN_MSME_USER_ACCOUNT_ID";
